import { MenuItem, TableCell, TableRow } from '@material-ui/core'
import _ from 'lodash'
import React from 'react'

// utils
import { hasAccess } from '../../utils/api'
import { onChangeEditHOF } from '../../utils/common'
import { EditableSelect, EditableSwitch, EditableTextField } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import TaxChangesConfirmationModal from './TaxChangesConfirmationModal'
import { buildTaxDisplayNameChanges } from './taxChangeUtils'

export default class TaxDisplayNameItem extends React.Component {
  state = {
    showChangeConfirmation: false,
    pendingChanges: [],
  }

  editSnapshot = null

  onChange = onChangeEditHOF(this.props.onChange)

  saveChanges = () => {
    this.props.onSave((response) => {
      this.editSnapshot = null
      if (this.props.clearEditingIndex) this.props.clearEditingIndex()
      if (this.props.disableEdit) this.props.disableEdit()
      this.props.handleAnyEdit(false)
    })
  }

  onSave = () => {
    const changes = buildTaxDisplayNameChanges(
      this.editSnapshot || {},
      this.props.data || {},
      this.props.taxTypeOptions || [],
    )

    if (!changes.length) {
      this.saveChanges()
      return
    }

    this.setState({
      showChangeConfirmation: true,
      pendingChanges: changes,
    })
  }

  onCancel = () => {
    this.editSnapshot = null
    if (this.props.clearEditingIndex) this.props.clearEditingIndex()
    if (this.props.onCancel) this.props.onCancel()
    this.props.handleAnyEdit(false)
  }

  onEdit = () => {
    this.editSnapshot = _.cloneDeep(this.props.data || {})
    if (this.props.setEditingIndex) this.props.setEditingIndex()
    if (this.props.enableEdit) this.props.enableEdit()
    this.props.handleAnyEdit(true)
  }

  closeChangeConfirmation = () => {
    this.setState({
      showChangeConfirmation: false,
      pendingChanges: [],
    })
  }

  confirmChangeAndSave = () => {
    this.setState({ showChangeConfirmation: false }, this.saveChanges)
  }

  render() {
    const {
      data = {},
      isEditing = false,
      companyFeatures = {},
      taxTypeMapping = false,
      taxTypeOptions = [],
      showEdit = true,
      requireParentEditForTaxMapping = false,
    } = this.props
    const { showChangeConfirmation, pendingChanges } = this.state
    const selectedTaxType = taxTypeOptions?.find((opt) => opt.value === data.taxType)?.label

    const mappingScope = data.taxTerritory ? `${data.taxTerritory} Tax Mapping` : 'Tax Mapping'
    const mappingTitle = `${mappingScope} - Confirm Changes`

    // Delivery Tax can require the parent form to be in edit mode before Tax Mapping is editable.
    const canEditTaxMapping = showEdit || isEditing || !requireParentEditForTaxMapping
    // Keep the current row editable while enforcing the one-section-at-a-time rule.
    const canStartEditing = !this.props.isAnyEditing || isEditing
    const shouldShowEditAction = canEditTaxMapping && canStartEditing

    return (
      <React.Fragment>
        <TaxChangesConfirmationModal
          open={showChangeConfirmation}
          title={mappingTitle}
          changes={pendingChanges}
          onClose={this.closeChangeConfirmation}
          onConfirm={this.confirmChangeAndSave}
        />
        <TableRow>
          <TableCell>{data.taxTerritory || ''}</TableCell>
          <TableCell className="cell-wrap-word">
            <EditableTextField
              valueToRender={data.name || ''}
              editMode={isEditing}
              value={data.name}
              onChange={this.onChange('name')}
              type="text"
            />
          </TableCell>
          {companyFeatures.enableAppendTax ? (
            <TableCell className="cell-wrap-word">
              <EditableSwitch
                valueToRender={data.appendTax ? 'Enabled' : 'Disabled'}
                checked={data.appendTax}
                editMode={isEditing}
                onChange={this.onChange('appendTax', true)}
              />
            </TableCell>
          ) : null}
          {taxTypeMapping && (
            <TableCell className="cell-wrap-word">
              <EditableSelect
                value={data.taxType ?? 'none'}
                onChange={this.onChange('taxType')}
                valueToRender={selectedTaxType ?? 'None'}
                editMode={isEditing}
              >
                <MenuItem value="none">None</MenuItem>
                {taxTypeOptions.map(({ value, label }) => (
                  <MenuItem value={value} key={value}>
                    {label}
                  </MenuItem>
                ))}
              </EditableSelect>
            </TableCell>
          )}
          <TableCell className="cell-wrap-word">
            {hasAccess() && shouldShowEditAction ? (
              <div>
                <EditActionComponent
                  onSave={this.onSave}
                  onCancel={this.onCancel}
                  onEdit={this.onEdit}
                  editMode={isEditing}
                  disabled={!isEditing && this.props.isAnyEditing}
                />
              </div>
            ) : null}
          </TableCell>
        </TableRow>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TaxOption/TaxDisplayNameItem.js